import { computed, toValue, type ComputedRef, type MaybeRefOrGetter } from 'vue'
import { useWorkspaceMembers } from './useWorkspaceMembers'

/**
 * Gets the profile image URL for the given user ID. Returns
 * null if the user has no profile image or if the user doesn't
 * exist in the active workspace.
 */
export const useProfileImage = (userId: MaybeRefOrGetter<string>): ComputedRef<string | null> => {
  const workspaceMembersStore = useWorkspaceMembers()

  const user = computed(() =>
    workspaceMembersStore.workspaceMembers.find(({ id }) => {
      return id === toValue(userId)
    }),
  )

  return computed<string | null>(() => user.value?.profilePictureUrl ?? null)
}
